import { BaseCard } from './Card';
import { SearchBar } from './Searchbar';
import { Modal } from './Modal';
import { BaseTypography } from './Typography';
import { StudentForm, QueryForm } from './Forms';
import { BaseButton, BaseIconButton, BaseFab } from './Buttons';
import { ConfirmDialog } from './ConfirmDialog';
import { Notification, NotificationSlide } from './Notification';
import { SimpleBackDrop } from './Backdrop';
import {  Input, Select, DatePicker, Checkbox, RadioGroup } from './Inputs'



import {
    QueryResultsTblContainer, 
    QueryResultsTblHead, 
    QueryResultsTblBody, 
    QueryResultsTblPagination, 
    DetailedTblContainer, 
    DetailedTblHead, 
    DetailedTblBody
} from './Tables'


const Components = {
    Input,
    BaseFab,
    BaseButton,
    BaseIconButton,
    BaseCard,
    Select,
    StudentForm,
    QueryForm,
    DatePicker,
    Checkbox,
    RadioGroup,
    QueryResultsTblContainer,
    QueryResultsTblHead,
    QueryResultsTblBody,
    QueryResultsTblPagination,
    DetailedTblContainer,
    DetailedTblHead,
    DetailedTblBody,
    SearchBar,
    Modal,
    BaseTypography,
    Notification,
    NotificationSlide,
    ConfirmDialog,
    SimpleBackDrop,
}

export default Components
 